import * as React from 'react'
import styles from './TableScrollingContainer.sass'

/**
 * Table Scrolling Container. Put the <Table> inside of this.
 */
export default React.forwardRef<
  HTMLDivElement,
  {
    children?: React.ReactNode
  }
>(function TableScrollingContainer({ children, ...rest }, ref) {
  return (
    <div ref={ref} className={styles.root} {...rest}>
      {children}
    </div>
  )
})
